import template from './trip-item-eurail-recommendation.html';
import tripEvents from './../../config/events.constant';
import tripStatuses from './../../trip-statuses';

const DIRECTIVE_NAME = TripItemEuRailRecommendation.DIRECTIVE_NAME = 'ktTripItemEurailRecommendation';
export default function TripItemEuRailRecommendation() {
    return {
        restrict: 'A',
        template,
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
            cancellation: `=${DIRECTIVE_NAME}Cancellation`,
            cancelTrip: `=${DIRECTIVE_NAME}CancelTrip`,
            isCancelled: `=${DIRECTIVE_NAME}IsCancelled`,
            getTooltip: `=${DIRECTIVE_NAME}GetTooltip`,
            showAcceptDismissForBooker: `=${DIRECTIVE_NAME}ShowAcceptDismissForBooker`,
            lastReview: `=${DIRECTIVE_NAME}LastReview`,
        },
        controller: TripItemEuRailRecommendationController,
        controllerAs: 'tripItemEuRailRecommendationCtrl',
        link: function($scope, $elem, $attrs, tripItemEuRailRecommendationCtrl) {
            tripItemEuRailRecommendationCtrl.$onInit();
        },
    };
}

export function TripItemEuRailRecommendationController(
    $scope,
    tripItemService,
    railsUtils,
    tripUtils,
    userService,
    tripDetailsService,
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    Object.assign($scope, {
        cancelTripItem,
        applyReview,
        isItemReviewed,
        isTripItemIdDeclined,
        isTripItemIdApproved,
        isItemNotIndicated,
        itemCannotBeCancelled: tripItemService.itemCannotBeCancelled,
    });

    function $onInit() {
        $scope.seatsCount = tripDetailsService.getSeatsCount($scope.tripDetails);
        $scope.regionalSettings = userService.getRegionalSettings();
        $scope.travellersCount = tripDetailsService.getTravellersCount($scope.tripDetails);

        $scope.firstRail = railsUtils.firstRail;
        $scope.lastRail = railsUtils.lastRail;
        $scope.findFlightStop = railsUtils.findFlightStop;
        $scope.findDestination = railsUtils.findDestination;
        $scope.railType = railsUtils.railType;
        $scope.isEurostar = railsUtils.isItemTrain;
        $scope.generateRulesParameters = tripUtils.generateRulesParameters;
        $scope.showItemReviewStatus = $scope.lastReview && $scope.lastReview.needToShowTripItems() && $scope.showAcceptDismissForBooker();
        $scope.isNotCCUser = $scope.tripDetails.ReviewTripInfo.CanBeCommented || $scope.tripDetails.ReviewTripInfo.CanBeAccepted;
        $scope.isSingleReviewer = $scope.tripDetails.ReviewTripInfo.CanBeAccepted;
        $scope.tripDetails.reviewModel = $scope.tripDetails.reviewModel || {flights: {}, cars: {}, hotels: {}, rails: {}, euRails: {}};
        $scope.isTripConfirmed = isTripConfirmed();
    }

    function cancelTripItem(item) {
        this.cancellation.cancellingWholeTrip = false;
        $scope.$emit(tripEvents.TRIP_CANCEL_ITEM, item);
    }

    function applyReview(rail, isAccepted) {
        $scope.tripDetails.reviewModel.euRails[rail.Id] = isAccepted;
    }

    function isItemReviewed(railId) {
        return $scope.tripDetails.reviewModel
            && $scope.tripDetails.reviewModel.euRails
            && $scope.tripDetails.reviewModel.euRails.hasOwnProperty(railId);
    }

    function isTripItemIdDeclined(tripItemId) {
        return $scope.showItemReviewStatus && $scope.lastReview.getFirstUserReview().isTripItemIdDeclined(tripItemId);
    }

    function isTripItemIdApproved(tripItemId) {
        return $scope.showItemReviewStatus && $scope.lastReview.getFirstUserReview().isTripItemIdApproved(tripItemId);
    }

    function isItemNotIndicated(tripItemId) {
        return $scope.showItemReviewStatus
            && $scope.lastReview.getFirstUserReview().isTripItemIdNotInticated(tripItemId);
    }

    function isTripConfirmed() {
        return $scope.tripDetails.Status === tripStatuses.CONFIRMED;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-recommendation/trip-item-eurail-recommendation/trip-item-eurail-recommendation-component.js